import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import pageLoader from '../images/loader_big.svg';
import '../styles/sanJournals.css';

import { TextInput, Selectize, DateInput, CheckFilter, TimeInput, CheckGroup, SubmitButton, SwitchFilter } from '../forms/FormItems';
import { ButtonSelectGroup } from '../shared/FormElements';
import { TablePagination, TableReportPage } from './PageTemplates';
import { EmptyResultInformer, FormModal, InlineError, OpenShiftInformer } from '../shared/FeedbackComponents';
import { AddButton, AddIconButton, ExpandIconButton, FilterIconButton, ItemNewHeader, MainFilterBlock, RemoveIconButton } from '../shared/PageComponents';

import { toSelectList, toCheckList } from './../functions';

import { uistate, confirmState } from '../stores/common';
import { CheckIcon, ClockIcon, UserIcon, InfoIcon, InvoiceFillIcon} from '../images/icons';
import { FilialApi, InvoiceApi, ProductApi, ProviderApi, RoleApi, SanJournalApi, UserApi } from '../stores/apiMethods';
import { SanJournalFillingState, SanJournalManageState, SJReportState } from '../stores/sanJournals';

/** Временный флаг автоматической прокрутки к строкам, добавленным из модальных окон */
const ENABLE_ADDED_ROWS_SCROLL = true;

/** Прокрутка страницы к первой добавленной строке журнала с fallback для старых Android WebView */
function scrollToAddedRow(journalIndex, rowIndex) {
	if (!ENABLE_ADDED_ROWS_SCROLL || _.isUndefined(rowIndex) || typeof document === "undefined") return;

	const scroll = () => {
		const row = document.querySelector('[data-journal-index="' + journalIndex + '"] [data-row-index="' + rowIndex + '"]');
		if (!row || !row.scrollIntoView) return;

		try {
			if ("scrollBehavior" in document.documentElement.style)
				row.scrollIntoView({ behavior : "smooth", block : "center" });
			else row.scrollIntoView(false);
		} catch (error) {
			row.scrollIntoView(false);
		}
	};
	const nextFrame = typeof window !== "undefined" && window.requestAnimationFrame
		? window.requestAnimationFrame.bind(window)
		: (callback) => setTimeout(callback, 0);

	nextFrame(() => nextFrame(scroll));
}

/**
 * СТРАНИЦА НАСТРОЙКИ САНИТАРНЫХ ЖУРНАЛОВ
 * На данной странице происходит настройка шаблонов сан журналов.
 * 
 ** /api/Filials – метод, возвращающий список филиалов
 ** /api/Roles – метод, возвращающий список должностей
 ** /api/Users – метод, возвращающий список пользователей
 */

export class SanJournalManagePage extends Component {
	constructor(props) {
		super(props);

		this.store = new SanJournalManageState();
	}

	/** Загрузка журналов, шаблонов и справочников страницы после монтирования */
	componentDidMount() {
		this.getData();

		FilialApi.getList((data) => {
			this.store.Filials = data.Success && !_.isNull(data.Filials) ? data.Filials : [];
		});
		UserApi.getList(undefined, (data) => {
			this.store.UserList = data.Success && !_.isNull(data.Users) ? data.Users : [];
		});
		RoleApi.getList(false, (data) => {
			this.store.Roles = data.Success && !_.isNull(data.Roles) ? data.Roles : [];
		});
		SanJournalApi.getList(true, (data) => { this.store.setTemplates(data); });
	}

	/** API запрос на получение списка санжурналов */
	getData() {
		this.store.IsSendRequest = false;
		SanJournalApi.getList(false, (data) => { this.store.setLists(data); });
	}

	/**
	 * API запрос «GetSanJournals» на получение СЖ
	 * @param {number} id ID чек листа
	 * @param {string} type тип действия
	 */
	getItem = (id, type) => {
		SanJournalApi.getById(id, (data) => {
			this.store.setList(data.Success ? data : undefined, type);
			if (data.Success && type === "update") this.store.Journal.showSuccess();
		});
	}

	/**
	 * Выбор СЖ из списка
	 * @param {number} id ID чек листа
	 * @param {string} type тип действия
	 */
	setId = (id, type) => {
		if (!_.isUndefined(id) && id !== -1) this.getItem(id, type);
		else {
			this.store.setList(undefined)
			this.getData();
		}
	}

	/**
	 * API запрос «ChecklistRemove» на удаление чек листа
	 * @param {number} id ID чек-листа
	 */
	removeId = (id) => {
		if (_.isUndefined(id)) return false;

		var item = _.find(this.store.Lists, { Id: id }),
			text = <span>Вы действительно хотите удалить журнал <b key="b1">«{item ? item.Name : ""}»</b> для филиала <b key="b2">«{item ? item.Filial : ""}»</b>?</span>;

		confirmState.openConfirm(text, () => { SanJournalApi.remove(id, () => { this.getData(); }); });
	}

	render() {
		return (
			<div className={"page " + (uistate.IsMobile ? "mobile" : uistate.IsTablet ? "tablet" : "")} id="sjManagePage">
				{_.isUndefined(this.store.Journal) &&
					<section>
						<div className="head">
							<h2>Мои журналы</h2>
							{uistate.isDevice &&
								<p>Редактирование сан журналов доступо только на десктопной версии</p>
							}
						</div>
						{this.store.IsSendRequest &&
							_.isEmpty(this.store.Lists) ? <EmptyResultInformer />
							: <TableReportPage
								Type={this.props.Type}
								TableData={this.store.Lists}
								TableColumns={this.store.ListColumns}
								TableFilterable={true}

								editRow={this.setId}
								removeRow={this.removeId}
							/>
						}
						{!_.isEmpty(this.store.Templates) &&
							<>
								<h2>Готовые шаблоны журналов</h2>
								<TableReportPage
									Type={this.props.Type}
									TableData={this.store.Templates}
									TableColumns={this.store.TemplateColumns}
									TableFilterable={true}

									editRow={this.setId}
								/>
							</>
						}
					</section>
				}
				{!_.isUndefined(this.store.Journal) &&
					<JournalItem
						Journal={this.store.Journal}
						Filials={this.store.Filials}
						Roles={this.store.Roles}
						Users={this.store.Users}
						CanManage={this.store.CanManage}
						setId={this.setId}
						getItem={this.getItem}
					/>
				}
			</div>
		)
	}
}
SanJournalManagePage = observer(SanJournalManagePage);

class JournalItem extends Component {
	/** API запрос «SaveSanitaryJournal» на сохранение СЖ */
	handleSubmit = (event) => {
		event.preventDefault();

		if (!this.props.Journal.validate()) return false;
		this.props.Journal.ButtonLoading = true;

		SanJournalApi.save(this.props.Journal.getData(), (data) => {
			this.props.Journal.ButtonLoading = false;
			this.props.Journal.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			this.props.Journal.SuccessSave = data.Success;
			
			if (data.Success) this.props.getItem(data.Id, "update");
		});
	}

	render() {
		return (
			<section className="item" id="sjItem">
				<form onSubmit={this.handleSubmit} >
					<ItemNewHeader
						Title={"Настройка журнала"}
						ErrorCode={this.props.Journal.ErrorCode}
						ButtonLoading={this.props.Journal.ButtonLoading}
						CanManage={this.props.CanManage && !uistate.isDevice}
						SuccessSave={this.props.Journal.SuccessSave}
						handleClose={() => this.props.setId() }
					/>
					<MainSettings
						Journal={this.props.Journal}
						Filials={this.props.Filials}
						Roles={this.props.Roles}
						Users={this.props.Users}
					/>
					<FieldsBlock Journal={this.props.Journal} />
				</form>
			</section>
		)
	}
}
JournalItem = observer(JournalItem);

class MainSettings extends Component {
	render() {
		return (
			<div className='section main'>
				<div>
					<TextInput
						Id="Name"
						Title="Название"
						Required={true}
						Value={this.props.Journal.Name}
						Disabled={true}
					/>
					<p>{this.props.Journal.Description}</p>
					{this.props.Journal.IsLampJournal &&
						<div className="lampSettings">
							<TextInput
								Id="AddName"
								Title="Название лампы/установки"
								Required={true}
								Value={this.props.Journal.AddName}
								Disabled={this.props.Journal.Id >= 1}
								onChange={(value, id) => this.props.Journal.collect(id, value)}
							/>
							<TextInput
								Id="StartRemainingWorkHours"
								Title="Начальное оставшееся время работы"
								Required={true}
								Type="number"
								Icon="час"
								IconType="text"
								Value={this.props.Journal.StartRemainingWorkHours}
								Disabled={this.props.Journal.Id >= 1}
								onChange={(value, id) => this.props.Journal.collect(id, value)}
							/>
						</div>
					}
					<p className='comment'>Выберите отвественного за заполнение журнала — это может быть должность или конкретный пользователь.</p>
					<div className='roles'>
						<Selectize
							Id="RoleId"
							Title="Должность"
							List={toSelectList(this.props.Roles)}
							Disabled={uistate.isDevice}
							Value={this.props.Journal.RoleId}
							onChange={(value, id) => this.props.Journal.collect(id, value)}
						/>
						<Selectize
							Id="UserId"
							Title="Пользователь"
							List={toSelectList(this.props.Users)}
							Disabled={uistate.isDevice}
							Value={this.props.Journal.UserId}
							onChange={(value, id) => this.props.Journal.collect(id, value)}
						/>
					</div>
				</div>
				<div>
					<p className='comment'>Необходимо выбрать конкретный филиал, для которого будет произведена дальнейшая настройка.</p>
					<Selectize
						Id="FilialId"
						Title="Филиал"
						List={toSelectList(this.props.Filials)}
						Disabled={uistate.isDevice || this.props.Journal.Id >= 1}
						Value={this.props.Journal.FilialId}
						onChange={(value, id) => this.props.Journal.collect(id, value)}
					/>
				</div>
			</div>
		)
	}
}
MainSettings = observer(MainSettings);

class FieldsBlock extends Component {
	render() {
		return(
			<div className='section fields'>
				<h3>Поля заполнения журнала</h3>
				<p>{this.props.Journal.Instructions}</p>
				<div className='list'>
					<>
						<h5>Название поля</h5>
						<h5>Возможные значения</h5>
						{!uistate.IsMobile &&
							<h5>Инструкции по настройке</h5>
						}
					</>
					{_.map(this.props.Journal.Fields, (item, i) => {
						return(<FieldItem key={i} Item={item} Index={i} />)
					})}
				</div>
			</div>
		)
	}
}

class FieldItem extends Component {
	/** Перевод фокуса на добавленную строку справочника после обновления списка */
	componentDidUpdate() {
		if (!this.focusAddedListItem || !this.lastListInput || !this.lastListInput.input) return;

		this.lastListInput.input.focus();
		this.focusAddedListItem = false;
	}

	/** Добавление строки справочника с последующим переводом фокуса */
	addListItem = () => {
		this.focusAddedListItem = true;
		this.props.Item.addListItem();
	}

	render() {
		return (
			<>	
				<div>
					<p>{this.props.Item.Name}</p>
					<p className='comment'>{this.props.Item.TypeTitle}</p>
				</div>
				<div className={'values ' + (this.props.Item.IsList || this.props.Item.ListType ? "list " : "") + (this.props.Item.CanSetDefault ? "default" : "")}>
					{!_.isUndefined(this.props.Item.Steps) &&
						<SwitchFilter
							Id="Range"
							RowClass="nomargin"
							Type="bool"
							List={[{ Id : false, Name : "Значение"}, {Id : true, Name : "Диапазон"}]}
							Value={this.props.Item.Range}
							onChange={(value, id) => this.props.Item.collect(id, value)}
						/>
					}
					{this.props.Item.CanSetDefault && !this.props.Item.Range &&
						<>
							{this.props.Item.IsBoolean &&
								<SwitchFilter
									Id="Value"
									Title="Значение по умолчанию"
									List={[{ Id : false, Name : "Нет"}, {Id : true, Name : "Да"}]}
									Type="bool"
									Value={this.props.Item.Value}
									onChange={(value, id) => this.props.Item.collect(id, value)}
								/>
							}
							{!this.props.Item.IsBoolean && !this.props.Item.IsList &&
								<TextInput
									Id="Value"
									Title="Значение по умолчанию"
									Type={this.props.Item.IsNumber ? "number" : "text"}
									Step={this.props.Item.Type === 2 ? 1 : 0.001}
									Value={this.props.Item.Value}
									onChange={(value, id) => this.props.Item.collect(id, value)}
								/>
							}
						</>
					}
					{this.props.Item.CanSetDefault && this.props.Item.Range &&
						<>	
							<div className='range'>
								<TextInput
									Id="Min"
									Title="Минимум"
									Type="number"
									Step={this.props.Item.Type === 2 ? 1 : 0.001}
									Value={this.props.Item.Min}
									onChange={(value, id) => this.props.Item.collect(id, value)}
								/>
								<TextInput
									Id="Max"
									Title="Максимум"
									Type="number"
									Step={this.props.Item.Type === 2 ? 1 : 0.001}
									Value={this.props.Item.Max}
									onChange={(value, id) => this.props.Item.collect(id, value)}
								/>
							</div>
							<ButtonSelectGroup
								Id="Step"
								Title="Точность"
								List={this.props.Item.Steps}
								Value={this.props.Item.Step}
								onChange={(value, id) => this.props.Item.collect(id, value)}
							/>
						</>
					}
					{(this.props.Item.IsList || this.props.Item.ListType) &&
						<>
							{this.props.Item.ShowERPSettings &&
								<SwitchFilter
									Id="ListType"
									RowClass="nomargin listType"
									Type="bool"
									List={[{ Id : false, Name : "Свой список"}, {Id : true, Name : "ERP справочник"}]}
									Value={this.props.Item.ListType}
									Disabled={!this.props.Item.CanChangeListType}
									onChange={(value, id) => this.props.Item.collect(id, value)}
								/>
							}
							{this.props.Item.IsList && (!this.props.Item.HasERP || !this.props.Item.ListType) &&
								_.map(this.props.Item.List, (item,i) => {
									return(<FieldListItem Item={item} Index={i} key={i}
									Field={this.props.Item} CanDefault={this.props.Item.CanSetDefault} Value={this.props.Item.Value}
									CanAdd={!uistate.isDevice && i === this.props.Item.List.length - 1}
									CanRemove={!uistate.isDevice && this.props.Item.List.length > 1}
									addListItem={this.addListItem}
									InputRef={!uistate.isDevice && i === this.props.Item.List.length - 1 ?
										(input) => this.lastListInput = input : undefined} />)
									})
							}
							{this.props.Item.HasERP && this.props.Item.ListType &&
								<Selectize
									Id="ErpDictionary"
									Title="ERP справочник"
									RowClass="nomargin erpDictionary"
									List={toSelectList(this.props.Item.ErpDictionaries)}
									Multi={true}
									Value={this.props.Item.ErpDictionary}
									onChange={(value, id) => this.props.Item.collect(id, value)}
								/>
							}
						</>
					}
					{this.props.Item.CalcTitle !== "" &&
						<p>{this.props.Item.CalcTitle}</p>
					}
				</div>
				{!uistate.IsMobile &&
					<p className='comment'>
						{this.props.Item.IsReportDate &&
							"Значение даного поля будет использоваться для формирования даты отчета. "
						}
						{this.props.Item.Instruction}
					</p>
				}
			</>
		)
	}
}
FieldItem = observer(FieldItem);

class FieldListItem extends Component {
	/** Добавление новой строки справочника по Enter без отправки формы */
	handleKeyDown = (event) => {
		if (event.key !== "Enter") return;

		event.preventDefault();
		if (this.props.CanAdd) this.props.addListItem();
	}

	render() {
		return (
			<>	
				{this.props.CanDefault &&
					<CheckGroup
						Id="IsDefault"
						Type="checkbox"
						RowClass="nomargin"
						List={[{ Id : this.props.Item.Id, Title : "", Description: "Выбрать по умолчанию" }]}
						Value={[this.props.Value]}
						onChange={(value, id) => this.props.Field.collect(id, value, this.props.Index)}
					/>
				}
				<TextInput
					Id="Value"
					RowClass="nomargin"
					Value={this.props.Item.Value}
					Disabled={uistate.isDevice}
					onChange={(value, id) => this.props.Item.collect(id, value)}
					onKeyDown={this.handleKeyDown}
					ref={this.props.InputRef}
				/>
				{this.props.CanAdd ?
					<AddIconButton onClick={this.props.addListItem} /> : <p></p>
				}
				{this.props.CanRemove ?
					<RemoveIconButton onClick={() => this.props.Field.deleteListItem(this.props.Index)} /> : <p></p>
				}
			</>
		)
	}
}
FieldListItem = observer(FieldListItem);

/**
 * РАЗДЕЛ ЗАПОЛНЕНИЯ САН ЖУРНАЛОВ
 * Отображаются журналы, настроенные к заполнению в открытой смене 
 * Каждый журнал можно развернуть и заполнить конкретный СЖ
 * В журнале бракеража, если есть доступ к ERP, отображается список продуктов и полуфабрикатов
 * В гигиеническом журнале доступно окно выбора сотрудников на смену
 * 
 ** /api/Products – метод, отдающий список товаров для интеграции с ERP
 *
 ** /api/GetSanJournals – метод, отдающий список строк СЖ для заполнения
 */
/** Основная страница */
export class SanJournalPage extends Component {
	constructor(props) {
		super(props);

		this.store = new SanJournalFillingState();
	}

	/** Загрузка журналов и товаров ERP после монтирования страницы */
	componentDidMount() {
		if (this.store.IsShiftActive) {
			this.getData();

			if (this.store.HasERP) {
				ProductApi.getList({ Active : true }, (data) => {
					this.store.ProductList = data.Success && !_.isNull(data.Products) ? data.Products : [];
				});
				ProviderApi.getList(true, (data) => {
					this.store.ProviderList = data.Success && !_.isNull(data.Providers) ? data.Providers : [];
				});
			}
		}
	}

	/** API запрос на получение шаблонов СЖ к заполнению */
	getData() { 
		this.store.ButtonLoading = true;
		SanJournalApi.getFilling((data) => { this.store.setJournals(data); });
	}

	

	/** API запрос на сохранение хаписей в журнал */
	handleSubmit = (event) => {
		event.preventDefault();
		this.store.ErrorCode = "";
		this.store.ButtonLoading = true;

		SanJournalApi.saveFilling(this.store.getData(), (data) => {
			this.store.SuccessSave = data.Success;
			this.store.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			
			if (data.Success) this.store.setJournals(data);
			else this.store.ButtonLoading = false;
			
			setTimeout(() => { this.store.ErrorCode = ""; }, 3000);
		});
	}

	render() {
		var device = uistate.IsMobile ? "mobile" : uistate.IsTablet ? "tablet" : "",
			style = { left : uistate.IsTablet ? 50 : uistate.IsSideBarOpen ? 260 : 50 };

		return (
			<div className={"page " + device} id="SjPage">
				<section className='item'>
					<form onSubmit={this.handleSubmit}>
						<div className="head" style={style}>
							<h2>Санитарные журналы</h2>
							<InlineError ErrorCode={this.store.ErrorCode} Success={this.store.SuccessSave} />
							{this.store.IsShiftActive &&
								<SubmitButton Title="Сохранить" Loading={this.store.ButtonLoading} />
							}
						</div>
						{this.store.IsShiftActive && this.store.IsSendRequest &&
							(!_.isEmpty(this.store.Journals)
								? _.map(this.store.Journals, (journal, i) => (
									<SJFillJournal Item={journal} store={this.store}
										key={"jor_" + journal.TemplateType + "_" + i} Index={i} />
								))
								: <EmptyResultInformer />
							)
						}
						{!this.store.IsShiftActive && <OpenShiftInformer Text="Откройте смену для работы с сан. журналами" />}
					</form>
				</section>
				{!_.isUndefined(this.store.Workers) &&
					<SJWorkersBlock
						Item={this.store.Workers}
						Journal={this.store.Journals[this.store.Workers.Journal]}
						onClose={() => this.store.openWorkers()}
					/>
				}
				{!_.isUndefined(this.store.Date) &&
					<SJDateBlock
						Item={this.store.Date}
						Journal={this.store.Journals[this.store.Date.Journal]}
						onClose={() => this.store.openDate()}
					/>
				}
				{!_.isUndefined(this.store.Invoices) &&
					<SJInvoiceBlock 
						Item={this.store.Invoices}
						Journal={this.store.Journals[this.store.Invoices.Journal]}
						onClose={() => this.store.openInvoices()}
					/>
				}
			</div>
		)
	}
}
SanJournalPage = observer(SanJournalPage);

/** Блок одного журнала */
class SJFillJournal extends Component {
	constructor(props) {
		super(props);

		this.state = { isOpen : false }
	}

	/** Добавление строки в журнал */
	handleAdd = () => {
		if (this.props.Item.IsJournalGroup || !_.isEmpty(this.props.Item.MultiList))
			this.props.store.openDate(this.props.Index)
		else this.props.Item.addRow();
	}

	render() {
		var template = this.props.Item.RowClass ? { "gridTemplateColumns" : this.props.Item.RowClass} : {};

		return(
				<div className='journal section' data-journal-index={this.props.Index}>
				<div className='header'>
					<h3>{this.props.Item.Name}</h3>
					{this.props.Item.IsHygiene && !_.isEmpty(this.props.Item.WorkersList) &&
						<button type="button" className="button secondary iconSvg"
							onClick={() => this.props.store.openWorkers(this.props.Index)}><UserIcon /> Выбрать сотрудников на смене</button>
					}
					{this.props.store.HasERP && this.props.Item.IsInvoiceJournal &&
						<button type="button" className="button secondary iconSvg"
							onClick={() => this.props.store.openInvoices(this.props.Index)}><InvoiceFillIcon /> Заполнить из накладной</button>
					}
					<ExpandIconButton IsOpen={this.state.isOpen} onClick={() => this.setState({ isOpen : !this.state.isOpen })} />
				</div>
				<p>{this.props.Item.Description}</p>
				{this.state.isOpen &&
					<>
						<div className={'list type_' + this.props.Item.TemplateType} >
							{_.map(this.props.Item.Rows, (row, i) => {
								return(
									<div className='row' data-row-index={i} style={template} key={i}>
										{this.props.Item.canDeleteRow(i)
											? <RemoveIconButton onClick={() => this.props.Item.deleteRow(i)} />
											: <span className='remove'>&nbsp;</span>
											}
										{this.props.Item.IsJournalGroup &&
											<TextInput
												Id="AddName"
												Title="Название установки"
												Value={row.AddName}
												Disabled={true}
											/>
										}
										{_.map(row.Fields, (field, k) => {
											return(<SJFillField Item={field} Index={k} Row={i} Journal={this.props.Index} 
												TemplateType={this.props.Item.TemplateType} store={this.props.store} key={"r" + i + "f" + k} />)
										})}
									</div>
								)
							})}
						</div>
						<div className='buttons'>
							<AddButton Title="Добавить запись в журнал" onClick={this.handleAdd} />
							{this.props.Item.NeedAccept &&
								<button type="button" className="button green secondary iconSvg"
									onClick={() => this.props.Item.acceptRows()}><CheckIcon /> Подтвердить записи</button>
							}
						</div>
					</>
				}
			</div>
		)
	}
}
SJFillJournal = observer(SJFillJournal);

/** Ячейка заполнения */
class SJFillField extends Component {
	render() {
		var erpDictionary = this.props.store.getErpDictionary(this.props.Item.ErpDictionary);

		if (this.props.Item.Type === 1) {
			if (this.props.Item.CanUseERP && !_.isEmpty(erpDictionary)) {
				return(
					<Selectize
						Id="Value"
						Title={this.props.Item.Name}
						Value={this.props.Item.Value}
						List={toSelectList(erpDictionary)}
						onChange={(value, id) => this.props.Item.collect(value)}
					/>
				)
			} else 
				return(
					<TextInput
						Id="Value"
						Title={this.props.Item.Name}
						Value={this.props.Item.Value}
						RowClass={this.props.Item.NeedAccept ? "accept" : ""}
						onChange={(value, id) => this.props.Item.collect(value)}
					/>
				)
		} else if (this.props.Item.IsNumber)
			return(
				<TextInput
					Id="Value"
					Type="number"
					RowClass={this.props.Item.NeedAccept ? "accept" : ""}
					Step={this.props.Item.Type === 2 ? 1 : 0.001}
					Title={this.props.Item.Name}
					Value={this.props.Item.Value}
					onChange={(value, id) => this.props.Item.collect(value)}
				/>
			)
		else if (this.props.Item.IsDate)
			return(
				<DateInput
					Id="Value"
					Title={this.props.Item.Name}
					Value={this.props.Item.Value}
					IsClearable={false}
					WithTime={this.props.Item.Type === 6}
					onChange={(value, id) => this.props.Item.collect(value)}
				/>
			)
		else if (this.props.Item.Type === 5) 
			return(
				<TimeInput
					Id="Value"
					Title={this.props.Item.Name}
					Value={this.props.Item.Value}
					onChange={(value, id) => this.props.Item.collect(value)}
				/>
			)
		else if (this.props.Item.Type === 7)
			return(
				<CheckFilter
					Id="Value"
					Title={this.props.Item.Name}
					Value={this.props.Item.Value}
					RowClass={uistate.IsMobile || (uistate.IsTablet && this.props.TemplateType === 5) ? "nomargin" : ""}
					onChange={(value, id) => this.props.Item.collect(value)}
				/>
			)
		else if (this.props.Item.Type === 8)
			return(
				<Selectize
					Id="Value"
					Title={this.props.Item.Name}
					Value={this.props.Item.Value}
					List={toSelectList(this.props.Item.Values)}
					Disabled={this.props.Item.Values.length === 1}
					onChange={(value, id) => this.props.Item.collect(value)}
				/>
			)
		else if (this.props.Item.Type === 9) {
			return(
				<TextInput
					Id="Value"
					Title={this.props.Item.Name}
					Value={this.props.Item.ValueTitle}
					Disabled={true}
				/>
			)
		}

		return(
			<TextInput
				Id="Value"
				Title={this.props.Item.Name}
				Value={this.props.Item.Value}
				Disabled={true}
			/>
		)
	}
}
SJFillField = observer(SJFillField);


/** Окно выбора накладной для заполнения журнала входного контроля */
class SJInvoiceBlock extends Component {
	componentDidMount() {
		this.getInvoices();
	}

	/**
	 * API запрос на зрагузку накладных
	 * @param {number} offset сдвиг
	 */
	getInvoices = (offset = 0) => {
		if (this.props.Item.Loading) return;
		
		this.props.Item.Loading = true;
		this.props.Item.ErrorCode = "";
		this.props.Item.Filter.Offset = offset;

		InvoiceApi.getList(this.props.Item.Filter, (data) => {
			this.props.Item.setInvoices(data);
			this.props.Item.Loading = false;
		})
	}

	/** API запрос на загрузку выбранной накладной
	 * @param {number} id ID выбранной накладной
	 */
	getInvoice = (id, title) => {
		if (this.props.Item.Loading) return;

		this.props.Item.Loading = true;
		this.props.Item.ErrorCode = "";
		
		InvoiceApi.getById(id, (data) => {
			if (data.Success && !_.isEmpty(data.Products)) {
				const firstRow = this.props.Journal.addInvoiceRows({...data, Title : title});
				this.props.onClose()
				scrollToAddedRow(this.props.Item.Journal, firstRow);
			} else 
				this.props.Item.ErrorCode = data.Success ? "INVOICE_PRODUCTS_REQUIRED" : data.ErrorCode;
			
			this.props.Item.Loading = false;
		});
	}

	render() {
		return(
				<FormModal
					ClassName="invoiceModal"
					Title={this.props.Item.Name}
					onClose={() => { if (!this.props.Item.Loading) this.props.onClose(); }}
				>
					<InlineError ErrorCode={this.props.Item.ErrorCode} />
					<div className="invoiceContent">
						{this.props.Item.Loading &&
							<div className="invoiceLoadingOverlay">
								<div className="loader"><img src={pageLoader} alt="loading" /></div>
							</div>
						}
						{this.props.Item.IsSendRequest && (_.isEmpty(this.props.Item.List)
							? <EmptyResultInformer Text="Доступные накладные не найдены" />
							: <>
								<div className="invoiceList">
									{_.map(this.props.Item.List, (invoice) => (
										<button
											type="button"
											className="invoice"
											disabled={invoice.Disabled || this.props.Item.Loading}
											onClick={() => this.getInvoice(invoice.Id, invoice.Title)}
											key={invoice.Id}
										>
											<span><b>{invoice.Title}</b> от {invoice.Date}</span>
											<span className='comment'>{invoice.Provider}</span>
										</button>
									))}
								</div>
								<TablePagination
									Limit={10}
									Offset={this.props.Item.Filter.Offset}
									HasMore={this.props.Item.HasMore}
									changePage={this.getInvoices}
								/>
							</>
						)}
					</div>
				</FormModal>
		)
	}
}
SJInvoiceBlock = observer(SJInvoiceBlock);

/** Окно выбора даты */
class SJDateBlock extends Component {
	/** Добавление строк журнала на выбранную дату */
	onConfirm = () => {
		if (this.props.Journal.IsJournalGroup)
			this.props.Journal.addGroupRows(this.props.Item.Date);
		else this.props.Journal.addMultiRows(this.props.Item.Date);
		this.props.onClose();
	}

	render() {
		return(
			<FormModal
				ClassName="dateModal"
					Title={this.props.Item.Name}
					onSubmit={this.onConfirm}
					onClose={this.props.onClose}
			>
				<DateInput
					Id="Date"
					Title="Выберите дату для новых записей"
						Value={this.props.Item.Date}
						IsClearable={false}
						WithTime={this.props.Item.Type === 6}
						onChange={(value, id) => this.props.Item.collect(id, value)}
				/>
			</FormModal>
		)
	}
}
SJDateBlock = observer(SJDateBlock);

/** Окно выбора сотрудников */
class SJWorkersBlock extends Component {
	/** Добавление строк для выбранных сотрудников и даты смены */
	onConfirm = () => {
		const firstRow = this.props.Journal.addWorkerRows(this.props.Item.Checked, this.props.Item.Date);
		this.props.onClose();
		scrollToAddedRow(this.props.Item.Journal, firstRow);
	}

	render() {
		return(
			<FormModal
				ClassName="workersModal"
					Title={this.props.Item.Name}
					onSubmit={this.onConfirm}
					onClose={this.props.onClose}
			>
				<DateInput
					Id="Date"
					Title="Выберите дату смены для новых записей"
						Value={this.props.Item.Date}
						IsClearable={false}
						onChange={(value,id) => { this.props.Item.collect(id, value); }}
				/>
				<CheckGroup
					Id="Checked"
					Title="Отметьте сотрудников на смене, чтобы заполнить для них журнал"
					Type="checkbox"
						List={toCheckList(this.props.Item.Workers)}
						Value={this.props.Item.Checked}
						onChange={(value, id) => this.props.Item.collect(id, value)}
				/>
			</FormModal>
		)
	}
}
SJWorkersBlock = observer(SJWorkersBlock);

/**
 ** ОТЧЕТ ПО ЗАПОЛНЕНИЮ САН ЖУРНАЛОВ
 * В отчетах отображается сводка по Заполнению журналов — название, филиал, кол-во записей
 * Каждый журнал можно развернуть и получить отчет по конкретному СЖ
 * 
 ** /api/Journals – метод, отдающий список СЖ для фильтра
 *
 ** /api/GetSanJournalReportStats – метод, отдающий список журналов
 ** /api/GetSanJournalReportSingle – метод, возвращающий конкретный журнал
 */

 /** Основная страница отчетов */
export class SJReport extends Component {
	constructor(props) {
		super(props);

		this.store = new SJReportState()
		this.state = { isOpen: false }
	}

	componentDidMount() {
		this.getData();

		SanJournalApi.getList(false, (data) => { this.store.JournalsList = data.Success ? data.List : []; });
	}

	/** API запрос для получения списка заполненных сан журналов */
	getData = () => {
		this.store.IsSendRequest = false;
		SanJournalApi.getReportList(this.store.Filter.getData(), (data) => { this.store.setReport(data); });
	}

	render() {
		return (
			<div id="SJReport" className={"page " + (uistate.IsMobile ? " mobile" : "")} >
				<div className="head">
					<div>
						<h2>Отчеты по заполнению сан журналов</h2>
						<FilterIconButton IsOpen={this.state.isOpen}
							onClick={() => this.setState({ isOpen: !this.state.isOpen })} />
					</div>
					<SJFilter
						Filter={this.store.Filter}
						Filials={this.store.Filials}
						Journals={this.store.Journals}
						IsOpen={this.state.isOpen}
						getData={this.getData}
					/>
				</div>
				{this.store.IsSendRequest && _.isEmpty(this.store.Report) &&
					<EmptyResultInformer />
				}
				{this.store.IsSendRequest && !_.isEmpty(this.store.Report) &&
					<SJReportBlock Report={this.store.Report} Filter={this.store.Filter} />
				}
			</div>
		)
	}
}
SJReport = observer(SJReport);

/** Блок фильтра */
class SJFilter extends Component {
	render() {
		return (
			<MainFilterBlock
				Filter={this.props.Filter}
				IsOpen={this.props.IsOpen}
				IsPartialOpen={false}
				MaxDate="today"
				onSubmit={this.props.getData}
			>
				<Selectize
					Id="FilialId"
					Title="Филиал"
					List={toSelectList(this.props.Filials)}
					Value={this.props.Filter.FilialId}
					onChange={(value, id) => this.props.Filter.collect(id, value)}
				/>
				<Selectize
					Id="JournalType"
					Title="Сан журнал"
					List={toSelectList(this.props.Journals)}
					Value={this.props.Filter.JournalType}
					onChange={(value, id) => this.props.Filter.collect(id, value)}
				/>
			</MainFilterBlock>
		)
	}
}
SJFilter = observer(SJFilter);

/** Таблица со списком журналов */
class SJReportBlock extends Component {
	render() {
		return (
			<div className='groups'>
				<>
					<h5>Название журнала</h5>
					{!uistate.isDevice &&
						<h5>Филиал</h5>
					}
					<h5>&nbsp;</h5>
					<h5>&nbsp;</h5>
				</>
				{_.map(this.props.Report, (item, i) => {
					return (<SJReportGroupsItem key={i} Item={item} Filter={this.props.Filter} 	/>)
				})}
			</div>
		)
	}
}
SJReportBlock = observer(SJReportBlock);

/** Строка с названием журнала */
class SJReportGroupsItem extends Component {
	constructor(props) {
		super(props);

		this.state = { isOpen: false }
	}

	/** Раскрытие группы или API метод «GetSanJournalReportSingle» для конкретного отчёта */
	getItem = () => {
		this.setState({ isOpen: !this.state.isOpen });

		if (!this.props.Item.IsGroup && _.isUndefined(this.props.Item.Fields))
			SanJournalApi.getReportById(this.props.Filter.getItem(this.props.Item.Id), (data) => {
				if (data.Success) this.props.Item.setJournal(data.Journal);
			});
	}

	render() {
		const isGroup = this.props.Item.IsGroup,
			isInstallation = this.props.IsInstallation,
			title = isInstallation ? this.props.Item.AddName : this.props.Item.Name;

		return (
			<>
				<span className='name'>
					<p>{title}</p>
					{!isInstallation && !isGroup && this.props.Item.AddName && <p className='comment'>{this.props.Item.AddName}</p>}
					{uistate.isDevice && <p className='comment'>Филиал: {this.props.Item.Filial}</p>}
				</span>
				{!uistate.isDevice && !isInstallation &&
					<span>{this.props.Item.Filial}</span>
				}
				{isInstallation && <span>{!_.isNull(this.props.Item.RemainingTime) &&
					<span className={'time ' + this.props.Item.RemainingState}><ClockIcon />{this.props.Item.RemainingTime}</span>
				}</span>}
				<span>{this.props.Item.RecordsCount} записей {uistate.isDevice ? "" : " в журнале"}</span>
				<span className='actions'>
					<ExpandIconButton IsOpen={this.state.isOpen} onClick={this.getItem} />
				</span>
				{this.state.isOpen && isGroup &&
					<div className='groupJournals'>
						{_.map(this.props.Item.Journals, (journal) => (
							<SJReportGroupsItem Item={journal} Filter={this.props.Filter}
								IsInstallation key={"installation_" + journal.Id} />
						))}
					</div>
				}
				{this.state.isOpen && !isGroup && !_.isUndefined(this.props.Item.Fields) &&
					<SJReportItemJournal Item={this.props.Item} key={"j" + this.props.Item.Id + "_" + this.props.Item.Filial} />
				}
			</>
		)
	}
}
SJReportGroupsItem = observer(SJReportGroupsItem);

/** Сам заполненный журнал */
class SJReportItemJournal extends Component {
	render() {
		var template = this.props.Item.Template ? { "gridTemplateColumns" : this.props.Item.Template} : {};

		return (
			<div className='journal'>
				<h4>{this.props.Item.Name}</h4>
				<p><span><InfoIcon /></span>{this.props.Item.Description}</p>
				<p><span><UserIcon /></span>{this.props.Item.Responsible}</p>
				{_.isEmpty(this.props.Item.Fields) &&
					<EmptyResultInformer Text="В журнале нет записей" />
				}
				{!_.isEmpty(this.props.Item.Fields) && this.props.Item.IsDateGroup && _.map(this.props.Item.Rows, (item) => {
					return(
						<SJReportDateGroup Item={item} Template = {template}
							Fields={this.props.Item.Fields} key={item.ReportDate} />
					)
				})}
				{!_.isEmpty(this.props.Item.Fields) && !this.props.Item.IsDateGroup &&
					<div className='fields' style={template}>
						{_.map(this.props.Item.Fields, (field, i) => {
							return(<h5 key={"h" + i}>{field}</h5>)
						})}
						<h5>Заполнил</h5>
						{_.map(this.props.Item.Rows, (row, k) => {
							return (<SJReportItemJournalRow Row={row} key={"row_" + this.props.Item.Id + "_" + k} />)
						})}
					</div>
				}
			</div>
		)
	}
}
SJReportItemJournal = observer(SJReportItemJournal);

class SJReportDateGroup extends Component {
	constructor(props) {
		super(props);

		this.state = { isOpen: false }
	}

	render() {
		return (
			<div className='date'>
				<div className='head'>
					<span>{this.props.Item.Date}</span>
					<ExpandIconButton IsOpen={this.state.isOpen}
						onClick={() => this.setState({ isOpen : !this.state.isOpen })} />
				</div>
				{this.state.isOpen &&
					<div className='fields' style={this.props.Template}>
						{_.map(this.props.Fields, (field, i) => {
							return(<h5 key={"h" + i}>{field}</h5>)
						})}
						<h5>Заполнил</h5>
						{_.map(this.props.Item.Items, (row, k) => {
							return (<SJReportItemJournalRow Row={row} key={"row_" + k} />)
						})}
					</div>
				}
			</div>
		)
	}
}
SJReportDateGroup = observer(SJReportDateGroup);

/** Заполненная строка журнала */
class SJReportItemJournalRow extends Component {
	render() {
		return (
			<>
				{_.map(this.props.Row.Fields, (item, j) => {
					return <span className={item.NotFilling ? "red" : ""} key={"s_" + j}>{item.Value}</span>
				})}
				<span>
					<p>{this.props.Row.User}</p>
					{/* <p className='comment'>{this.props.Row.Date}</p> */}
				</span>
			</>
		)
	}
}
SJReportItemJournalRow = observer(SJReportItemJournalRow);
